import { ref } from 'vue'

const changeHistoryModalOpen = ref(false)

export function useNGramChangeHistory() {
    return {
        changeHistoryModalOpen,
    }
}
